// extracted by mini-css-extract-plugin
module.exports = {"alignStepTwoBoxes":"InvestmentModalStepTwo_alignStepTwoBoxes__285Ep"};